/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable prefer-const */
'use client'; // Error boundaries must be Client Components

import {useEffect} from 'react';

import {ErrorPage} from '@udemy-v2/react-structure-components';
import {appConfig} from '@/app/lib/app-config';
import {Header} from '@/components/header';
import {Footer} from '@/components/footer';

// Add custom import statements for the error page below
// <<Stencil::Block(errorPageImports)>>
// <</Stencil::Block>>

export default function ErrorComponent({
    error,
    reset,
}: {
    error: Error & {digest?: string};
    reset: () => void;
}) {
    useEffect(() => {
        // Log the error to an error reporting service
        console.error(error);

        // Add custom error handling logic (e.g., error reporting, analytics) below
        // <<Stencil::Block(errorPageAdditionalHandling)>>
        // <</Stencil::Block>>
    }, [error]);

    /**
     * Error content component for error page
     * Can be customized via Stencil block for project-specific error displays
     */
    const ErrorContent = () => {
        let errorContent = <ErrorPage />;
        // Override default error content below
        // <<Stencil::Block(errorPageContent)>>
        // <</Stencil::Block>>
        return errorContent;
    };

    return (
        <>
            {!appConfig.useDefaultLayout ? <Header /> : null}
            <ErrorContent />
            {!appConfig.useDefaultLayout ? <Footer /> : null}
        </>
    );
}
